import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import './Auth.css';

const Register = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    password: '',
    userType: 'buyer',
    name: '',
    businessName: '',
    gstin: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await register(formData);
    
    if (result.success) {
      toast.success('Registration successful!');
      navigate('/');
    } else {
      toast.error(result.message);
    }
    
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Cixio</h1>
          <p>End-to-End Software Solutions — B2B & B2C</p>
        </div>

        <h2>Create your account</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>I am a</label>
            <select 
              name="userType" 
              className="form-control" 
              value={formData.userType}
              onChange={handleChange}
            >
              <option value="buyer">Buyer</option>
              <option value="seller">Seller/Manufacturer</option>
              <option value="lender">Lender/Insurance Partner</option>
              <option value="vendor">Logistics Vendor</option>
              <option value="delivery_partner">Delivery Partner</option>
              <option value="support">Support Team</option>
              <option value="admin">Admin</option>
            </select>
          </div>

          {formData.userType === 'seller' && (
            <>
              <div className="form-group">
                <label>GSTIN (Auto-fills business details)</label>
                <input
                  type="text"
                  name="gstin"
                  className="form-control"
                  placeholder="Enter your GST number"
                  value={formData.gstin}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Business Name</label>
                <input
                  type="text"
                  name="businessName"
                  className="form-control"
                  value={formData.businessName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Contact Person Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  placeholder="Full name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
            </>
          )}

          {(formData.userType === 'buyer' || formData.userType === 'consumer') && (
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Full name"
                value={formData.name}
                onChange={handleChange}
              />
            </div>
          )}

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              className="form-control"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Phone</label>
            <input
              type="tel"
              name="phone"
              className="form-control"
              placeholder="10-digit mobile number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              className="form-control"
              value={formData.password}
              onChange={handleChange}
              required
              minLength="6"
            />
          </div>

          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Creating account...' : 'Register'}
          </button>
        </form>

        <div className="auth-footer">
          <p>Already have an account? <Link to="/login">Login here</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Register;
